// firebase.js
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";


const firebaseConfig = {
  apiKey: "AIzaSyB2d3H-Vpgj9mCHtmx9FPsPE_XAabH9uiU",
  authDomain: "heyprompt-2d910.firebaseapp.com",
  projectId: "heyprompt-2d910",
  storageBucket: "heyprompt-2d910.firebasestorage.app",
  messagingSenderId: "436840426755",
  appId: "1:436840426755:web:d46fc50c9dad783d3a4d36",
  measurementId: "G-BQNZ7LL29D"
};


const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();


export { auth, provider };
export const db = getFirestore(app);

